
import React from "react";
import Layout from "@/components/layout/Layout";
import { SectionHeader } from "@/components/ui/section-header";
import { BlogCard } from "@/components/ui/blog-card";
import { blogPosts } from "@/data/blog-posts";
import { BookOpen } from "lucide-react";
import { SEOHead } from "@/components/seo/SEOHead";
import { generateBreadcrumbSchema } from "@/lib/schema";
import { BreadcrumbNavigation } from "@/components/ui/breadcrumb-list";

export default function BlogPage() {
  // Create breadcrumbs
  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Blog", url: "/blog" }
  ];

  // Generate breadcrumb schema
  const breadcrumbSchema = generateBreadcrumbSchema(breadcrumbs);

  return (
    <Layout>
      <SEOHead 
        title="Blog | Elderly Care Resources & Guides | Grandpal"
        description="Expert insights, practical guidance, and compassionate advice on elderly care, nursing homes, and the Fair Deal scheme in Ireland."
        canonicalUrl="/blog"
        schema={breadcrumbSchema}
      />
      
      <div className="bg-grandpal-beige/30">
        <div className="container max-w-7xl py-16 md:py-24">
          <div className="container mb-4">
            <BreadcrumbNavigation items={breadcrumbs.map(b => ({ label: b.name, href: b.url }))} />
          </div>

          <div className="flex items-center justify-center gap-3 mb-2">
            <BookOpen className="w-6 h-6 text-grandpal-green-dark" />
            <span className="text-sm font-medium uppercase tracking-wider text-grandpal-green-dark">Our Knowledge Hub</span>
          </div>
          
          <SectionHeader 
            title="Care & Support Resources" 
            subtitle="Expert insights, practical guidance, and compassionate advice on elderly care, nursing homes, and the Fair Deal scheme." 
            centered 
            className="mb-16" 
          />
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 animate-fade-in">
            {blogPosts.map(post => (
              <BlogCard 
                key={post.id} 
                title={post.title} 
                excerpt={post.excerpt} 
                slug={post.slug} 
                date={post.date} 
                imageUrl={post.imageUrl} 
                categories={post.categories} 
              />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}
